import React from 'react';
import SectionContainer from '../../components/SectionContainer';
import SectionHead from '../../components/SectionHead';
import ContactInfoBlock from './ContactInfoBlock';
import ContactMapFormBlock from './ContactMapFormBlock';

const Contact = () => {
  return (
    <SectionContainer id={'contact'} secName={'contact-sec'}>
      <SectionHead
        head={'contact'}
        text={
          'Contact us for innovative and reliable CAD design solutions that will elevate your business to the next level.'
        }
      />
      <ContactInfoBlock />
      <ContactMapFormBlock />
    </SectionContainer>
  );
};

export default Contact;
